import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Field, ObservableField } from '../../detail/detail.service';

@Component({
    selector: 'cml-dropdown',
    templateUrl: './cml-dropdown.component.html',
    styleUrls: ['./cml-dropdown.component.scss'],
    standalone: false
})
export class CmlDropDownComponent implements OnInit {
  _formControl!: FormControl;
  get formControl(): FormControl {
    return this._formControl;
  }
  @Input() set formControl(value: FormControl) {
    this._formControl = value;
    this.initValue();
  }

  @Input()
  errorMessage!: string

  @Input()
  field!: Field;

  values: any;

  selected: any;

  observableField!: ObservableField;

  initialized: boolean = false;

  constructor() {
  }

  ngOnInit() {
    if (this.field.observable) {
      this.observableField = this.field.observable;
    }
    this.initValue();
  }

  async initValue() {
    if (this.field && this.field.observable) {
      this.values = await this.field.observable.observable.toPromise();
      if(this.values){
        this.selected = this.values[0];
      }
      let idName = this.field.observable.optionValue;
      let val = this.values.find((x: any) => x[idName] === this.formControl.value);
      if (val) {
        this.selected = val;
      }
    }
    this.initialized = true;
  }

}
